import { MainButton, Typography } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { useMemo } from "react";
import i18n from "i18n/i18next";
import { routes } from "routing";
import { useRouteGuardContext } from "state/routeGuardProvider";
import { useGlobalRouter } from "feat/globalRouter/useGlobalRouter";
import { useScreenTypeContext } from "../../state/screenTypeProvider";
import { useObjectContext } from "../providers/objectProvider";
interface IProviderButton {
  providerData: any;
}

export const ProviderButton = ({ providerData }: IProviderButton) => {
  const { isAllowed } = useRouteGuardContext();
  const { screenType } = useScreenTypeContext();
  const { _id } = useObjectContext();
  const { pushPath } = useGlobalRouter();

  const hasProvider = useMemo(() => {
    const canEdit = isAllowed(["allowedEdit"]);
    if (providerData && canEdit) {
      return true;
    }
    return false;
  }, [providerData, isAllowed]);

  if (!hasProvider) {
    return null;
  }
  if (screenType !== "upNext") return null;

  const path = () => {
    return routes.edit.hotelManage.build({ itemId: _id });
  };
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "space-between"
      }}>
      <Typography variant="bodyBold">{i18n.t("booking.manageYourBookings")}</Typography>
      <MainButton
        id={_id + "providerButton"}
        icon="Leave_App"
        size="small"
        onClick={() => {
          pushPath(path());
        }}
      />
    </Stack>
  );
};
